<template>
  <div class="item-back-options">
    <div class="form-group">
      <Label for="itemType" text="Categoria" />
      <select class="custom-select" id="itemType" v-model="itemType">
        <option v-for="(type, index) in types" :key="index" :value="type">
          {{ type }}
        </option>
      </select>
    </div>
    <div class="form-group">
      <Label for="itemName" text="Tipo (opcional)" />
      <input
        class="form-control"
        type="text"
        placeholder="Espada longa"
        id="itemSubType"
        v-model="itemSubType"
      />
    </div>
    <div class="form-group">
      <Label for="itemRarity" text="Raridade" />
      <select class="custom-select" id="itemRarity" v-model="itemRarity">
        <option v-for="(rarity, index) in rarities" :key="index" :value="rarity">
          {{ rarity }}
        </option>
      </select>
    </div>
    <div class="form-group">
      <SwitchComponent
        text="Requer sintonização?"
        id="itemRequiresAttunement"
        v-model="itemRequiresAttunement"
      />
    </div>
    <div class="form-group">
      <Label for="itemTextSize" text="Tamanho dos textos" />
      <select class="custom-select" id="itemTextSize" v-model="itemTextSize">
        <option v-for="(size, index) in textSizes" :key="index" :value="size">
          {{ size.name }}
        </option>
      </select>
    </div>
    <div class="form-group">
      <div class="d-flex justify-content-between align-items-center">
        <Label for="itemDescription" text="Descrição" />
        <span class="badge badge-light">
          {{ itemDescription.length }}/500
        </span>
      </div>
      <textarea
        class="form-control"
        id="itemDescription"
        v-model="itemDescription"
        maxlength="500"
        placeholder="Esta espada antiga foi feita com um metal raro retirado de um meteorito..."
        rows="4"
      ></textarea>
    </div>
    <div class="form-group">
      <div class="d-flex justify-content-between align-items-center">
        <Label for="itemEffects" text="Efeitos/Mecânicas" />
      </div>
      <textarea
        class="form-control effect-description"
        id="itemEffects"
        v-model="itemEffects"
        placeholder="Com este artefato, o usuário pode..."
        rows="4"
      ></textarea>
    </div>
    <a class="text-dark" href="https://commonmark.org/help/" target="_blank">
      <i class="fa fa-external-link"></i> Guia de formatação de texto
    </a>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { mapFields } from 'vuex-map-fields';

  import Label from './Label.vue';
  import SwitchComponent from './SwitchComponent.vue';

  export default {
    name: 'ItemBackOptions',
    components: {
      Label,
      SwitchComponent,
    },
    computed: {
      ...mapState([
        'item',
        'rarities',
        'textSizes',
        'types',
      ]),
      ...mapFields({
        itemDescription: 'item.description',
        itemEffects: 'item.effects',
        itemRarity: 'item.rarity',
        itemRequiresAttunement: 'item.requiresAttunement',
        itemTextSize: 'item.textSize',
        itemType: 'item.type',
        itemSubType: 'item.subType',
        itemShowLevels: 'item.showLevels',
      })
    }
  }
</script>

<style lang="scss" scoped>
  input,
  textarea,
  select {
    &::placeholder {
      color: #aaa !important;
      font-size: 80%;
    }
  }
</style>